import * as React from "react";
import classNames from "classnames";

interface IProps {
	className?: string;
	style?: {};
	children?: {};
}

const RequiredLabel: React.FC<IProps> = (props) => {
	return (
		<span className={classNames("label-required", props.className)}>
			{props.children}
		</span>
	);
};

export default RequiredLabel;
